import script from "./AppFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppFooter.vue?vue&type=script&lang=ts&setup=true"

import "./AppFooter.vue?vue&type=style&index=0&id=3ac8c128&lang=scss"

const __exports__ = script;

export default __exports__